import { observer } from 'mobx-react';
import * as React from 'react';
import { Component } from 'react';
import {autorun, reaction} from "mobx";

interface HiddenFieldProps {
    onChange;
    data;
}

@observer export class HiddenField extends Component<HiddenFieldProps, any> {

    autorun;
    value;

    componentDidMount(): void {
        this.autorun = autorun(() => {
            if (this.value !== this.props.data) {
                this.props.onChange(this.props.data);

                this.value = this.props.data;
            }
        });
    }

    componentWillUnmount(): void {
        this.autorun();
    }

    render() {
        return null;
    }

}
